import { useRef } from 'react'

import { useNavigate } from 'react-router-dom'

import { observer } from 'mobx-react-lite'

import { RoutingPaths } from 'app/routes/routes.ts'

import { BeketFindTicketForm } from 'entities/beket/models/find-ticket/model'
import listTicketsStore from 'entities/beket/models/ticket/beket-list-tickets/beket-list-tickets-store'

import { useInfiniteScroll } from 'shared/hooks/use-infinity-scroll.ts'

import { BeketHeader } from './components/beket-header'
import { BeketSearchList } from './components/beket-search-list'

interface Props {
  findFormBeket: BeketFindTicketForm
}

export const SearchResultBeket = observer(({ findFormBeket }: Props) => {
  const navigate = useNavigate()

  const targetRef = useRef<HTMLDivElement>(null!)

  const onHeaderClick = () => {
    navigate(RoutingPaths.beket.searchForm.path())
  }

  const onGoBack = () => {
    listTicketsStore.resetListOfTicket()

    navigate(RoutingPaths.beket.path())
  }

  useInfiniteScroll({
    targetRef,
    canLoad: listTicketsStore.page <= listTicketsStore.maxPage,
    onLoad: () => {
      void listTicketsStore.onGetTicketRequest(findFormBeket)
    },
  })

  return (
    <>
      <BeketHeader
        onGoBack={onGoBack}
        onClick={onHeaderClick}
      />

      <div className="container">
        <BeketSearchList />

        <div ref={targetRef} />
      </div>
    </>
  )
})
